export default "__VITE_ASSET__ffbc30d2__"